import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddProcedureComponent} from './add-procedure/add-procedure.component';
import {MaterialModule} from 'src/app/core/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from 'src/app/shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {
  MatInputModule, MatButtonModule, MatSelectModule, MatCardModule,
  MatAutocompleteModule, MatIconModule, MatProgressBarModule
} from '@angular/material';
import {NgMatAutocompleteModule} from 'src/app/shared/components/autocomplete/autocomplete.module';
import {NgZorroAntdModule} from 'ng-zorro-antd';
import {EditProcedureComponent} from './edit-procedure/edit-procedure.component';
import {ViewProcedureComponent} from './view-procedure/view-procedure.component';

@NgModule({
  declarations: [
    AddProcedureComponent,
    EditProcedureComponent,
    ViewProcedureComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    NgZorroAntdModule
  ],
  entryComponents: [
    AddProcedureComponent,
    EditProcedureComponent,
    ViewProcedureComponent,
  ]
})
export class ProcedureManagementModule {
}
